import { Divider, Grid2 as Grid, TextField, Typography } from '@mui/material';
import { DailyNavFtpConfigProps } from './DailyNavFtpConfig.props';

const DailyNavFtpConfig = ({
  disabled,
  ftpHost,
  ftpPort,
  ftpPath,
  ftpUsername,
  onFtpHostChange,
  onFtpPortChange,
  onFtpPathChange,
  onFtpUsernameChange,
}: DailyNavFtpConfigProps) => (
  <>
    <Divider sx={{ my: 3 }} />
    <Typography variant="h4" gutterBottom>
      FTP Delivery
    </Typography>
    <Typography variant="body2" sx={{ mb: 2 }}>
      Barebones send configuration. Transmission is not implemented yet; Send records the attempt and stores the
      report.
    </Typography>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          fullWidth
          size="small"
          id="daily-nav-ftp-host"
          label="FTP host"
          value={ftpHost}
          onChange={event => onFtpHostChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <TextField
          fullWidth
          size="small"
          type="number"
          id="daily-nav-ftp-port"
          label="Port"
          value={ftpPort}
          onChange={event => onFtpPortChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          fullWidth
          size="small"
          id="daily-nav-ftp-path"
          label="Path"
          value={ftpPath}
          onChange={event => onFtpPathChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          fullWidth
          size="small"
          id="daily-nav-ftp-username"
          label="Username"
          value={ftpUsername}
          onChange={event => onFtpUsernameChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  </>
);

export default DailyNavFtpConfig;
